import script from "./ReportsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsPage.vue?vue&type=style&index=0&id=336a612b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336a612b"]])

export default __exports__